import { Pagination as MantinePagination, PaginationProps, useMantineTheme } from '@mantine/core';
import { forwardRef } from 'react';

export type GradientVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

export interface ThemedPaginationProps extends PaginationProps {
  gradientVariant?: GradientVariant;
}

const Pagination = forwardRef<HTMLDivElement, ThemedPaginationProps>(
  ({ gradientVariant = 'primary', styles, ...rest }, ref) => {
    const theme = useMantineTheme();
    const gradient = theme.other.gradients[gradientVariant];

    return (
      <MantinePagination
        ref={ref}
        styles={{
          ...styles,
          control: {
            '&[data-active]': {
              backgroundImage: `linear-gradient(135deg, ${gradient.from}, ${gradient.to})`,
              borderColor: gradient.from,
              color: 'white',
            },
            ...(styles as any)?.control,
          },
        }}
        {...rest}
      />
    );
  }
);

Pagination.displayName = 'Pagination';

export default Pagination;
